module.exports = __webpack_public_path__ + "img/shortcut_app_off.5d726ca2.svg";